import { createSlice } from '@reduxjs/toolkit'
import { initialState, listReducers } from './listConstants'

const companyIncomingRequestsSlice = createSlice({
    name: 'ui/company-incoming-requests',
    initialState: { ...initialState, populates: ['location', 'hostId', 'contactIds'] },
    reducers: listReducers
})

export const companyIncomingRequestsActions = companyIncomingRequestsSlice.actions
export default companyIncomingRequestsSlice.reducer
